export default __webpack_public_path__ + "static/media/marauders-map-v0-01-02.ad677740.jpg";